module.exports = __webpack_public_path__ + "static/wes_headshot.bacd85dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wes_headshot.jpg
// module id = 466
// module chunks = 263791100135453